import { useCallback, useEffect } from 'react';

export default function AdobeTracking() {
  const setupAdobeTrackingVars = useCallback(() => {
    window.globalLmd = {
      bu: 'public',
      cc: window.locale.cc,
      language: window.locale.lang,
      pageName: 'Tech Today Hospital of the Future',
      storeID: 'TechToday',
      storeType: 'public_consumer',
    };
    window.lmd = window.globalLmd;
  }, []);

  const setupAdobeTrackingScript = useCallback(() => {
    const adobeAnalyticsUrl = process.env.REACT_APP_ADOBE_ANALYTICS_URL;
    if (undefined === adobeAnalyticsUrl) {
      return;
    }

    const adobeAnalyticsScriptExists = document.querySelector(
      'script[src="' + adobeAnalyticsUrl + '"]'
    );
    if (null !== adobeAnalyticsScriptExists) {
      return;
    }

    // Add Adobe Analytics
    const adobeAnalyticsScript = document.createElement('script');
    adobeAnalyticsScript.src = adobeAnalyticsUrl;
    adobeAnalyticsScript.onload = () => {
      // Append to bottom once Adobe has loaded
      const bottomScript = document.createElement('script');
      bottomScript.text = `_satellite.pageBottom();`;
      document.body.appendChild(bottomScript);
    };
    document.body.appendChild(adobeAnalyticsScript);
  }, []);

  useEffect(() => {
    const checkIfLocaleSet = () => {
      if (null !== window.locale) {
        setupAdobeTrackingVars();
        setupAdobeTrackingScript();
      } else {
        setTimeout(() => {
          checkIfLocaleSet();
        }, 100);
      }
    };

    checkIfLocaleSet();
  }, [setupAdobeTrackingVars, setupAdobeTrackingScript]);

  return null;
}
